import { Play } from 'lucide-react';
import { useState } from 'react';
import styles from './Trailer.module.css';

interface TrailerProps {
  title?: string;
  subtitle?: string;
  videoId?: string; // YouTube video ID
}

const Trailer = ({
  title = 'Watch the Reveal Trailer',
  subtitle = 'Experience the epic journey that awaits in Cosmos Horizon',
  videoId = 'dQw4w9WgXcQ' // Placeholder video ID
}: TrailerProps) => {
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlayClick = () => {
    setIsPlaying(true);
  };

  return (
    <section id="trailer" className={styles.trailer}>
      <div className={styles.background} />

      <div className={styles.container}>
        {/* Header */}
        <div className={styles.header}>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.subtitle}>{subtitle}</p>
        </div>

        {/* Video Container */}
        <div className={styles.videoWrapper}>
          {!isPlaying ? (
            <button
              className={styles.playButton}
              onClick={handlePlayClick}
              aria-label="Play trailer video"
            >
              <div className={styles.playIcon}>
                <Play size={48} fill="currentColor" />
              </div>
              <div className={styles.playBackground} />
              <span className={styles.playText}>Watch Trailer</span>
            </button>
          ) : (
            <div className={styles.videoContainer}>
              <iframe
                className={styles.video}
                src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`}
                title="Cosmos Horizon Trailer"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          )}

          {/* Ambient Glow */}
          <div className={styles.glow}>
            <div className={styles.glowInner} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Trailer;
